/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerMaintenancePricingCombinationRequestDto
 */
export interface PartnerMaintenancePricingCombinationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenancePricingCombinationRequestDto
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerMaintenancePricingCombinationRequestDto
     */
    takeChargeMinutes?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PartnerMaintenancePricingCombinationRequestDto
     */
    interventionMinutes?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PartnerMaintenancePricingCombinationRequestDto
     */
    resolutionMinutes?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PartnerMaintenancePricingCombinationRequestDto
     */
    priceAmount?: number | null;
}

/**
 * Check if a given object implements the PartnerMaintenancePricingCombinationRequestDto interface.
 */
export function instanceOfPartnerMaintenancePricingCombinationRequestDto(value: object): value is PartnerMaintenancePricingCombinationRequestDto {
    return true;
}

export function PartnerMaintenancePricingCombinationRequestDtoFromJSON(json: any): PartnerMaintenancePricingCombinationRequestDto {
    return PartnerMaintenancePricingCombinationRequestDtoFromJSONTyped(json, false);
}

export function PartnerMaintenancePricingCombinationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerMaintenancePricingCombinationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'takeChargeMinutes': json['takeChargeMinutes'] == null ? undefined : json['takeChargeMinutes'],
        'interventionMinutes': json['interventionMinutes'] == null ? undefined : json['interventionMinutes'],
        'resolutionMinutes': json['resolutionMinutes'] == null ? undefined : json['resolutionMinutes'],
        'priceAmount': json['priceAmount'] == null ? undefined : json['priceAmount'],
    };
}

export function PartnerMaintenancePricingCombinationRequestDtoToJSON(json: any): PartnerMaintenancePricingCombinationRequestDto {
    return PartnerMaintenancePricingCombinationRequestDtoToJSONTyped(json, false);
}

export function PartnerMaintenancePricingCombinationRequestDtoToJSONTyped(value?: PartnerMaintenancePricingCombinationRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'takeChargeMinutes': value['takeChargeMinutes'],
        'interventionMinutes': value['interventionMinutes'],
        'resolutionMinutes': value['resolutionMinutes'],
        'priceAmount': value['priceAmount'],
    };
}

